












































import { Vue, Component } from 'vue-property-decorator';
import { Field } from 'vant/types/field';
import { Toast } from 'vant';
import i18n from '@/lang/index';
// 报名设置
@Component
export default class enrollSetting extends Vue {
  get enrollForm() {
    return this.$store.state.courseEnrollForm;
  }
  private visibleAddEnrollInfo: boolean = false;
  private newEnrollTitle: string = ''
  delItem(index: number) {
    this.enrollForm.formLists.splice(index, 1)
  }
  // 显示 添加报名信息 弹框
  showAddEnrollTitle() {
    this.visibleAddEnrollInfo = true;
    this.$nextTick(() => {
      const newEnrollTitle = this.$refs.newEnrollTitle as Field;
      newEnrollTitle.focus()
    })
    this.newEnrollTitle = '';
  }
  // 添加报名信息
  addEnrollInfo() {
    if(!this.newEnrollTitle) {
      Toast(i18n.t('Home.请输入标题'))
      return;
    }
    this.enrollForm.formLists.push({
      seleted: '1',
      title: this.newEnrollTitle,
    })
    this.visibleAddEnrollInfo = false;
  }

  // 选择审核模式
  private visibleReviewMode: boolean = false;
  readonly reviewModeList = [
    { name: i18n.t('Home.自动审核'), value: '0' },
    { name: i18n.t('Home.手动审核'), value: '1' },
  ]
  showReviewMode() {
    this.visibleReviewMode = true;
  }
  onSelect(item: { name: string, value: string }) {
    console.log(item);
    this.enrollForm.auditstate = item.value;
    this.visibleReviewMode = false;
  }

  destroyed() {
    sessionStorage.setItem('inCreate', '1');
  }
};
